import { createFeatureSelector, createSelector } from '@ngrx/store';
import { DocumentGenerationState } from './state';

export const DocumentGenerationFeature = 'DocumentGenerationFeature';

export const documentGeneratingFeatureStateSelector =
  createFeatureSelector<DocumentGenerationState>(DocumentGenerationFeature);

export const selectGeneratingClauseList = createSelector(
  documentGeneratingFeatureStateSelector,
  (state: DocumentGenerationState) => state.generatingClauseList,
);

export const selectGenerateClauseListFailed = createSelector(
  documentGeneratingFeatureStateSelector,
  (state: DocumentGenerationState) => state.generateClauseListFailed,
);

export const selectGenerateClauseListResponse = createSelector(
  documentGeneratingFeatureStateSelector,
  (state: DocumentGenerationState) => state.generateClauseListResponse,
);

export const selectLastGenerateClauseListPayload = createSelector(
  documentGeneratingFeatureStateSelector,
  (state: DocumentGenerationState) => state.lastGenerateClauseListPayload,
);

export const selectDocumentGenerationTrackingId = createSelector(
  documentGeneratingFeatureStateSelector,
  (state: DocumentGenerationState) =>
    state.generateClauseListResponse?.documentGenerationTrackingId || null,
);

export const selectDocumentGenerationResponse = createSelector(
  documentGeneratingFeatureStateSelector,
  (state: DocumentGenerationState) => state.generateDocumentResponse,
);

export const selectGeneratingDocument = createSelector(
  documentGeneratingFeatureStateSelector,
  (state: DocumentGenerationState) => state.generatingDocument,
);

export const selectStartAskingGenerateDocumentStatus = createSelector(
  documentGeneratingFeatureStateSelector,
  (state: DocumentGenerationState) => state.askingGenerateDocumentStatus,
);

export const selectCloseGenerateDocumentModal = createSelector(
  documentGeneratingFeatureStateSelector,
  (state: DocumentGenerationState) => state.closeGenerateDocumentModal,
);

export const selectCreatingDocumentOperationsAreInProgress = createSelector(
  documentGeneratingFeatureStateSelector,
  (state: DocumentGenerationState) => state.creatingDocumentOperationsAreInProgress,
);
